(function () {
  if (window.__mgProductMainInit) return;
  window.__mgProductMainInit = true;

  document.querySelectorAll('[id^="mg-pdp-"]').forEach(function (root) {
    var sectionId = root.id.replace('mg-pdp-', '');
    var data = (window.mgProductData || {})[sectionId];
    if (!data) return;

    var variants = data.variants || [];
    var packIndex = data.packIndex;
    var sizeIndex = data.sizeIndex;

    var state = { pack: null, size: null };

    // ---- Gallery ----
    var mainImg = root.querySelector('[data-mg-gal-main-img]');
    var thumbs = root.querySelectorAll('[data-mg-gal-thumbs] .mg-gal-thumb');
    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function switchToThumb(thumb) {
      thumbs.forEach(function (t) { t.classList.remove('mg-is-on'); });
      thumb.classList.add('mg-is-on');
      if (mainImg) {
        mainImg.src = thumb.getAttribute('data-mg-gal-full');
        mainImg.alt = thumb.getAttribute('data-mg-gal-alt') || '';
      }
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { switchToThumb(thumb); });
      // Hover-to-preview only on devices with a real mouse — on touch
      // devices a tap fires both a hover-ish state and a click in some
      // browsers, so relying on hover there would be redundant at best
      // and unreliable at worst. Click remains the primary interaction
      // everywhere; this just adds an instant preview for mouse users
      // who'd otherwise have to click first to see each image.
      if (supportsHover) {
        thumb.addEventListener('mouseenter', function () { switchToThumb(thumb); });
      }
    });

    // ---- Thumbnail scroll arrows (left-hand gallery layout only) ----
    // The bottom-thumbnails layout wraps into rows and never scrolls, so
    // this only does anything when the thumbs sit in a column next to
    // the main image. CSS alone can't reliably cap that column's height
    // to match the main image here — the grid row's "auto" height and
    // the column's own content height are circularly dependent in this
    // layout, so the column just grows to fit every thumbnail instead of
    // stopping at the image's edge. Measuring the image directly and
    // setting an explicit pixel height sidesteps that entirely.
    var thumbsWrap = root.querySelector('[data-mg-gal-thumbs-wrap]');
    var thumbsScroller = root.querySelector('[data-mg-gal-thumbs]');
    var mainImgEl = root.querySelector('[data-mg-gal-main]');
    if (thumbsWrap && thumbsScroller && mainImgEl) {
      var upBtn = thumbsWrap.querySelector('[data-mg-gal-scroll="up"]');
      var downBtn = thumbsWrap.querySelector('[data-mg-gal-scroll="down"]');

      function updateThumbArrows() {
        var canScroll = thumbsScroller.scrollHeight > thumbsScroller.clientHeight + 1;
        if (!canScroll) {
          upBtn.hidden = true;
          downBtn.hidden = true;
          return;
        }
        upBtn.hidden = false;
        downBtn.hidden = false;
        upBtn.disabled = thumbsScroller.scrollTop <= 0;
        downBtn.disabled = thumbsScroller.scrollTop + thumbsScroller.clientHeight >= thumbsScroller.scrollHeight - 1;
      }

      function scrollThumbs(direction) {
        var amount = thumbsScroller.clientHeight * 0.8;
        thumbsScroller.scrollBy({ top: direction === 'down' ? amount : -amount, behavior: 'smooth' });
      }

      function syncThumbsHeight() {
        var h = mainImgEl.getBoundingClientRect().height;
        if (h > 0) thumbsWrap.style.height = h + 'px';
        updateThumbArrows();
      }

      if (upBtn) upBtn.addEventListener('click', function () { scrollThumbs('up'); });
      if (downBtn) downBtn.addEventListener('click', function () { scrollThumbs('down'); });
      thumbsScroller.addEventListener('scroll', updateThumbArrows);
      window.addEventListener('resize', syncThumbsHeight);
      if (window.ResizeObserver) {
        new ResizeObserver(syncThumbsHeight).observe(mainImgEl);
      }
      syncThumbsHeight();
    }

    // ---- Pack / size selection ----
    var packRow = root.querySelector('[data-mg-pack-row]');
    var sizeRow = root.querySelector('[data-mg-size-row]');

    if (packRow) {
      var packButtons = packRow.querySelectorAll('[data-mg-pack-value]');
      packButtons.forEach(function (btn, i) {
        // Reads whichever button the section already marked as selected
        // (Most loved -> Pack of 1 -> any available, decided server-side
        // in Liquid) instead of blindly assuming the first DOM button —
        // those aren't always the same one.
        if (btn.classList.contains('mg-is-on')) state.pack = btn.getAttribute('data-mg-pack-value');
        btn.addEventListener('click', function () {
          packButtons.forEach(function (b) { b.classList.remove('mg-is-on'); });
          btn.classList.add('mg-is-on');
          state.pack = btn.getAttribute('data-mg-pack-value');
          updatePriceForSelection();
        });
      });
    }

    if (sizeRow) {
      var sizeButtons = sizeRow.querySelectorAll('[data-mg-size-value]');
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeButtons.forEach(function (b) { b.classList.remove('mg-is-on'); });
          btn.classList.add('mg-is-on');
          state.size = btn.getAttribute('data-mg-size-value');
          sizeRow.classList.remove('mg-is-warn');
          updatePriceForSelection();
        });
      });
    }

    // Syncs the displayed price with whatever pack/size the section
    // already marked as selected on load (e.g. "Most loved" by default)
    // — without this, the price block just showed Shopify's own default
    // variant price until the customer clicked something themselves.
    updatePriceForSelection();

    function findMatchingVariant() {
      return variants.find(function (v) {
        var packOk = packIndex === null || packIndex === undefined || packIndex < 0 || state.pack === null || v['option' + (packIndex + 1)] === state.pack;
        var sizeOk = sizeIndex === null || sizeIndex === undefined || sizeIndex < 0 || state.size === null || v['option' + (sizeIndex + 1)] === state.size;
        return packOk && sizeOk;
      });
    }

    function money(cents) {
      return (data.moneyFormat || '{{amount}}').replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    function updatePriceForSelection() {
      var variant = findMatchingVariant();
      if (!variant) return;
      var nowEl = root.querySelector('[data-mg-price-now]');
      var wasEl = root.querySelector('[data-mg-price-was]');
      var saveEl = root.querySelector('[data-mg-price-save]');
      if (nowEl) nowEl.textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (wasEl) { wasEl.textContent = money(variant.compare_at_price); wasEl.hidden = false; }
        if (saveEl) { saveEl.textContent = 'You save ' + money(variant.compare_at_price - variant.price); saveEl.hidden = false; }
      } else {
        if (wasEl) wasEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
      // Note: deliberately not touching the free-shipping message here —
      // selecting a pack/size is just previewing, not purchasing, so it
      // should have zero effect on a message that's meant to reflect
      // what's actually in the cart right now.
    }

    // ---- Free shipping message ----
    // Previously this only compared the selected variant's own price
    // against the threshold — completely ignoring whatever the customer
    // already had in their cart. Fetches the real, current cart total,
    // then always shows threshold vs. (actual cart total + this
    // selection) — i.e. "here's where you'd stand if you added this."
    var shipMsg = root.querySelector('[data-mg-ship-msg]');
    var cartTotalCents = 0;

    function refreshCartTotal(callback) {
      // cache: 'no-store' is required here — without it, the browser can
      // serve a stale cached response to this fetch, which is why the
      // message previously showed correctly only after a full page
      // reload (a real navigation isn't subject to the same fetch cache).
      fetch((((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')).replace(/\/$/, '') + '/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartTotalCents = cart.total_price || 0;
          if (callback) callback();
        })
        .catch(function () {
          if (callback) callback();
        });
    }

    function updateShippingMessage() {
      if (!shipMsg) return;
      var thresholdMajor = parseFloat(shipMsg.getAttribute('data-threshold'));
      if (!thresholdMajor) return;
      var projectedMajor = cartTotalCents / 100;
      if (projectedMajor >= thresholdMajor) {
        shipMsg.textContent = 'Free shipping unlocked';
        shipMsg.classList.add('mg-is-hit');
      } else {
        shipMsg.textContent = 'Add ' + money((thresholdMajor - projectedMajor) * 100) + ' more to get free shipping';
        shipMsg.classList.remove('mg-is-hit');
      }
    }
    if (variants.length && shipMsg) {
      refreshCartTotal(function () {
        updateShippingMessage();
      });
    }

    // Dawn publishes a real "cart-update" event through its own pub/sub
    // system (assets/pubsub.js + constants.js) whenever the cart changes
    // through ANY mechanism — including removing an item or changing
    // quantity inside the cart drawer, not just our own add-to-cart call.
    // Without listening for this, our cached cart total only ever knew
    // about changes we made ourselves, so a removal elsewhere left this
    // message stale until a full page reload.
    function subscribeToCartUpdates() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refreshCartTotal(function () {
          updateShippingMessage();
        });
      });
      return true;
    }
    if (shipMsg && !subscribeToCartUpdates()) {
      // constants.js/pubsub.js load deferred in <head>, so if this script
      // happened to run before they finished, DOMContentLoaded (which
      // always fires after deferred scripts) is a safe point to retry.
      document.addEventListener('DOMContentLoaded', subscribeToCartUpdates);
    }

    // ---- Email offer toggle ----
    var emailbox = root.querySelector('[data-mg-emailbox]');
    if (emailbox) {
      emailbox.addEventListener('click', function () {
        emailbox.classList.toggle('mg-is-on');
      });
    }

    // ---- Size guide accordion link ----
    root.querySelectorAll('[data-mg-open-accordion]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('data-mg-open-accordion');
        var details = document.getElementById(targetId);
        if (details && details.tagName === 'DETAILS') {
          e.preventDefault();
          details.open = true;
          details.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    // ---- Add to cart ----
    // Reuses the exact same request shape + drawer-refresh technique as
    // the product card's quick add (which already works correctly), since
    // a plain fetch to /cart/add.js only adds the item — it never tells
    // Dawn's <cart-drawer> to re-render itself or open, which is why the
    // drawer previously stayed stale and closed after a successful add.
    var addBtn = root.querySelector('[data-mg-add-to-cart]');
    var errorEl = root.querySelector('[data-mg-buy-error]');

    function getCartContainer() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function sectionsToRender(container) {
      if (container && typeof container.getSectionsToRender === 'function') {
        try {
          return container.getSectionsToRender().map(function (s) { return s.id; });
        } catch (e) { /* fall through to default */ }
      }
      return ['cart-icon-bubble', 'cart-drawer', 'cart-notification-product', 'cart-notification'];
    }

    function refreshCartIconOnly() {
      if (!document.getElementById('cart-icon-bubble')) return;
      fetch(window.location.pathname + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sectionsData) {
          var html = sectionsData['cart-icon-bubble'];
          var target = document.getElementById('cart-icon-bubble');
          if (target && html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('cart-icon-bubble');
            if (fresh) target.replaceWith(fresh);
          }
        })
        .catch(function () {});
    }

    function clearEmptyState(container) {
      if (!container) return;
      // Dawn's own cart-drawer.js only clears "is-empty" from
      // .drawer__inner — but the class is actually applied to <cart-drawer>
      // itself and to the separate <cart-drawer-items> element, which
      // Dawn's own code never touches. Left stuck, CSS scoped to
      // .is-empty keeps the freshly-injected (correct) content hidden
      // until a full page reload re-evaluates the cart from scratch —
      // exactly the "blank drawer until refresh" symptom.
      container.classList.remove('is-empty');
      var items = container.querySelector('cart-drawer-items');
      if (items) items.classList.remove('is-empty');
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        if (sizeRow && !state.size) {
          sizeRow.classList.add('mg-is-warn');
          sizeRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        var variant = findMatchingVariant();
        if (!variant) {
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'That combination is not available.'; }
          return;
        }

        var labelEl = addBtn.querySelector('[data-mg-add-label]');
        var originalLabel = labelEl ? labelEl.textContent : '';
        addBtn.disabled = true;
        if (labelEl) labelEl.textContent = 'Adding…';

        var cartContainer = getCartContainer();
        var cartAddUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '') + '/cart/add.js';

        // Matches Dawn's own product-form.js request shape exactly (single
        // id + quantity, not an "items" array) — that shape mismatch was
        // the specific cause of the cart-drawer render silently failing
        // the first time it went from empty to non-empty.
        var body = {
          id: variant.id,
          quantity: 1,
          sections: sectionsToRender(cartContainer),
          sections_url: window.location.pathname
        };

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, data: json }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errorEl) { errorEl.hidden = false; errorEl.textContent = (res.data && res.data.description) || 'Could not add to cart.'; }
              addBtn.disabled = false;
              if (labelEl) labelEl.textContent = originalLabel;
              return;
            }

            if (cartContainer && typeof cartContainer.renderContents === 'function') {
              // Uses the theme's own render + open logic, so the drawer
              // opens and behaves exactly like a native Dawn add to cart.
              try { cartContainer.renderContents(res.data); } catch (e) { /* corrected below */ }
              clearEmptyState(cartContainer);
              requestAnimationFrame(function () { clearEmptyState(cartContainer); });

              // Safety net: re-fetch and re-render a moment later. This
              // covers the same empty-to-non-empty race the quick add fix
              // addresses, where the very first render can lose the race
              // with the drawer's own setup and show stale content.
              var freshIds = sectionsToRender(cartContainer);
              setTimeout(function () {
                fetch(window.location.pathname + '?sections=' + freshIds.join(','))
                  .then(function (r) { return r.json(); })
                  .then(function (fresh) {
                    try { cartContainer.renderContents({ id: res.data.id, sections: fresh }); } catch (e) { /* ignore */ }
                    clearEmptyState(cartContainer);
                  })
                  .catch(function () {});
              }, 400);
            } else {
              refreshCartIconOnly();
            }

            if (labelEl) labelEl.textContent = 'Added';
            // Publishes the same event Dawn's own native product-form.js
            // fires after a successful add — this add bypasses that file
            // entirely (custom pack/size logic), so without this, other
            // Dawn components listening for cart changes (and our own
            // shipping-message subscription above) would never find out
            // this add happened.
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mg-product-main', cartData: res.data, variantId: variant.id });
            }
            refreshCartTotal(function () {
              updateShippingMessage();
            });
            setTimeout(function () {
              addBtn.disabled = false;
              if (labelEl) labelEl.textContent = originalLabel;
            }, 1800);
          })
          .catch(function () {
            addBtn.disabled = false;
            if (labelEl) labelEl.textContent = originalLabel;
            if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Could not add to cart.'; }
          });
      });
    }
  });
})();